import { combineReducers } from 'redux';

import help, * as fromHelp from './help';
import modals, * as fromModals from './modals';
import programs, * as fromPrograms from './programs';
import settings, * as fromSettings from './settings';
import terms, * as fromTerms from './terms';
import history, * as fromHistory from './history';
import ams, * as fromAms from './ams';
import reports from './reports';
import supporters, * as fromSupporters from './supporters';

import session, * as fromSession from './session';

const rootReducer = combineReducers({
  help,
  modals,
  programs,
  settings,
  terms,
  history,
  ams,
  session,
  reports,
  supporters,
});

// Session information
export const getIsLoggedIn = (state) => fromSession.getIsLoggedIn(state.session);
export const getIsSSOAccount = (state) => fromSession.getIsSSOAccount(state.session);
export const getIsLoginRequired = (state) => fromSession.getIsLoginRequired(state.session);
export const getIsAccountVerified = (state) => fromSession.getIsAccountVerified(state.session);
export const getSessionUserId = (state) => fromSession.getSessionUserId(state.session);
export const getSessionUserdata = (state) => fromSession.getSessionUserdata(state.session);
export const getSessionRoles = (state) => fromSession.getSessionRoles(state.session);
export const getSessionHasRole = (state, role) => fromSession.getSessionHasRole(state.session, role);
export const getSessionHasRoles = (state, roles) => fromSession.getSessionHasRoles(state.session, roles);

// TERMS
export const getTermsContent = (state) => fromTerms.getTermsContent(state.terms);
// HELP
export const getHelpContent = (state) => fromHelp.getHelpContent(state.help);
export const getHelpFile = (state) => fromHelp.getHelpFile(state.help);
export const getHelpOpen = (state) => fromHelp.getHelpOpen(state.help);

// MODALS
export const getPasswordModalOpen = (state) => fromModals.getPasswordModalOpen(state.modals);
export const getProgramModalOpen = (state) => fromModals.getProgramModalOpen(state.modals);
export const getHelpModalOpen = (state) => fromModals.getHelpModalOpen(state.modals);
export const getConfirmModalOpen = (state) => fromModals.getConfirmModalOpen(state.modals);
export const getTermsModalOpen = (state) => fromModals.getTermsModalOpen(state.modals);
export const getLoginFormModalOpen = (state) => fromModals.getLoginFormModalOpen(state.modals);

// PROGRAMS
export const getSelectedProgramID = (state) => fromPrograms.getSelectedProgramID(state.programs);
export const getSelectedProgram = (state) => fromPrograms.getSelectedProgram(state.programs);
export const getPrograms = (state) => fromPrograms.getPrograms(state.programs);
export const getProgramsLoading = (state) => fromPrograms.getProgramsLoading(state.programs);
export const getProgramsError = (state) => fromPrograms.getProgramsError(state.programs);
export const getProgramSaving = (state) => fromPrograms.getProgramSaving(state.programs);
export const getProgramSuccess = (state) => fromPrograms.getProgramSuccess(state.programs);
export const getProgramError = (state) => fromPrograms.getProgramError(state.programs);
export const getProgramDone = (state) => fromPrograms.getProgramDone(state.programs);
export const getProgramsByPaymentType = (state, paymentType) => fromPrograms.getProgramsByPaymentType(state.programs, paymentType);

// SETTINGS
export const getSettings = (state) => fromSettings.getSettings(state.settings);
export const getSettingsIsStaff = (state) => fromSettings.getSettingsIsStaff(state.settings);
export const getSettingsLoading = (state) => fromSettings.getSettingsLoading(state.settings);
export const getSettingsError = (state) => fromSettings.getSettingsError(state.settings);
export const getSettingsPersonal = (state) => fromSettings.getSettingsPersonal(state.settings);
export const getSettingsPersonalSaving = (state) => fromSettings.getSettingsPersonalSaving(state.settings);
export const getSettingsPersonalSuccess = (state) => fromSettings.getSettingsPersonalSuccess(state.settings);
export const getSettingsPersonalError = (state) => fromSettings.getSettingsPersonalError(state.settings);
export const getSettingsPersonalDone = (state) => fromSettings.getSettingsPersonalDone(state.settings);
export const getSettingsPasswordSaving = (state) => fromSettings.getSettingsPasswordSaving(state.settings);
export const getSettingsPasswordSuccess = (state) => fromSettings.getSettingsPasswordSuccess(state.settings);
export const getSettingsPasswordError = (state) => fromSettings.getSettingsPasswordError(state.settings);
export const getSettingsPasswordDone = (state) => fromSettings.getSettingsPasswordDone(state.settings);
export const getSettingsBilling = (state) => fromSettings.getSettingsBilling(state.settings);
export const getSettingsBillingSaving = (state) => fromSettings.getSettingsBillingSaving(state.settings);
export const getSettingsBillingSuccess = (state) => fromSettings.getSettingsBillingSuccess(state.settings);
export const getSettingsBillingError = (state) => fromSettings.getSettingsBillingError(state.settings);
export const getSettingsBillingDone = (state) => fromSettings.getSettingsBillingDone(state.settings);
export const getSettingsCreditCard = (state) => fromSettings.getSettingsCreditCard(state.settings);
export const getSettingsDirectDebit = (state) => fromSettings.getSettingsDirectDebit(state.settings);
export const getCardExpired = (state) => fromSettings.getCardExpired(state.settings);
export const getCardExpiring = (state, days = 30) => fromSettings.getCardExpiring(state.settings, days);

export const getHistory = (state) => fromHistory.getHistory(state.history);
export const getHistoryLoading = (state) => fromHistory.getHistoryLoading(state.history);
export const getHistoryError = (state) => fromHistory.getHistoryError(state.history);

export const getMessages = (state) => fromAms.getMessages(state.ams);
export const getMessagesLoaded = (state) => fromAms.getMessagesLoaded(state.ams);

// SUPPORTERS
export const getSupporters = (state) => fromSupporters.getSupporters(state.supporters);

export default rootReducer;
